import { modalRenderer } from '~/modal/modalRendererRegistry';
import {
  SendNavigationLinksModal, type SendNavigationLinksModalProps,
} from './shareNavigationLinksModal.component';

declare module '~/modal/modalRegistry.type' {
  interface ModalComponentRegistry {
    SendNavigationLinks: SendNavigationLinksModalProps;
  }
}

modalRenderer.register('SendNavigationLinks', SendNavigationLinksModal);
